import helpers from '../../util/helpers';

export default {
  init() {
    const body = $('body');
    const hotelBookingModal = $('.modal-hotel-booking');

    body.on('click', '.hotel-booking-modal-trigger', function (e) {
      e.preventDefault();

      body.addClass('right-side-open');
    });

    hotelBookingModal.on('click', '.hotel-booking-modal-close', function (e) {
      e.preventDefault();

      body.removeClass('right-side-open');
    });

    // Hotel Eat & Drink Reservation
    const hotelEatAndDrinkReservationModal = $('.hotel-eat-and-drink-reservation-modal');
    if (hotelEatAndDrinkReservationModal.length) {
      $(document).on('click', '.hotel-eat-and-drink-reservation-modal-trigger, .hotel-eat-and-drink-reservation-modal-close', function(e) {
        e.preventDefault();
        body.toggleClass('hotel-eat-and-drink-reservation-modal-mode');
        return false;
      });

      $(document).on('wpcf7invalid', function() {
        let requiredSelectField = hotelEatAndDrinkReservationModal.find('select.wpcf7-validates-as-required');
        if (requiredSelectField.length) {
          requiredSelectField.each(function() {
            let _this = $(this);

            if (_this.val() === '') {
              _this.addClass('wpcf7-not-valid');
            } else {
              _this.removeClass('wpcf7-not-valid');
            }
          });
        }
      });

      $(document).on('keydown', function(e) {
        if (body.hasClass('hotel-eat-and-drink-reservation-modal-mode')) {
          if (e.key === 'Escape') {
            body.removeClass('hotel-eat-and-drink-reservation-modal-mode');
            helpers.stopBodyScrolling(false);
          }
        }
      });
    }

    $('.overlay-close').on('click', function() {
      body.removeClass('right-side-open');
    });
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/components/modals.js